export default __webpack_public_path__ + "static/media/Tailwind-css-Logo.50fbcf51.svg";